import { Check } from "lucide-react";
import { PHASES, SITE } from "@/lib/content";
import { MaskLines, Reveal } from "@/components/site/Motion";
import { Disclaimer } from "./FounderStory";

export function Phases() {
  return (
    <section data-testid="programme-phases" className="relative bg-beige py-24 sm:py-32">
      <div className="wrap">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <div>
            <p className="eyebrow">The 120-day arc</p>
            <h2 className="mt-5 text-5xl leading-[0.98] text-forest sm:text-6xl"><MaskLines lines={["Four phases.", <em key="o" className="text-pine">One direction.</em>]} /></h2>
          </div>
          <Reveal><p className="font-script text-4xl leading-tight text-gold-ink">Real food · Real habits · Real results</p></Reveal>
        </div>
        <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {PHASES.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.1} className="h-full">
              <article className="group relative flex h-full flex-col overflow-hidden rounded-[28px] bg-forest p-7 text-cream transition-transform duration-700 hover:-translate-y-2" data-testid={`phase-${p.num}`}>
                <span className="absolute -right-4 -top-8 font-display text-[9rem] leading-none text-cream/[0.06] transition-transform duration-700 group-hover:scale-110">{p.num}</span>
                <span className="relative grid h-11 w-11 place-items-center rounded-full bg-gold font-display text-xl text-forest-deep">{p.num}</span>
                <h3 className="relative mt-6 font-display text-3xl">{p.title}</h3>
                <p className="relative mt-1 text-xs font-semibold uppercase tracking-[0.2em] text-gold-soft">{p.days}</p>
                <ul className="relative mt-6 space-y-3">
                  {p.points.map((pt) => <li key={pt} className="flex gap-3 text-sm text-cream/90"><Check className="mt-0.5 h-4 w-4 shrink-0 text-leaf" />{pt}</li>)}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>
        <div className="mt-8 flex flex-col justify-between gap-3 sm:flex-row sm:items-center">
          <p className="font-display text-3xl text-forest" data-testid="programme-price">{SITE.price}<span className="text-lg text-charcoal-soft"> /month · {SITE.days} days</span></p>
          <Disclaimer />
        </div>
      </div>
    </section>
  );
}
